import gql from 'graphql-tag';

const sharedBookingFragment = gql`
  fragment SharedBookingFragment on Booking {
    id
    bookingTimestamp
    retailerId
    caseReference
    campaignCode
    bookingReference
    bookingLanguage
    customer {
      title
      firstName
      lastName
      email
      phone
      streetAddress
      city
      postCode
    }
    timeslots {
      start
      end
      zonedStartTime
      zonedEndTime
    }
    appointmentDetails {
      price
      servicePrice
      customerInformation
      dropoffOptionTranslated
      dropoffOption
      pickupAddress
      primaryServices: primaryServicesEdges {
        node {
          uid
          classification
          price
          priceInfo
          heading
          details
          isContractApplied
        }
        comment
      }
      additionalServices {
        node {
          uid
          price
          priceInfo
          heading
          isContractApplied
        }
      }
      convenienceOptions {
        node {
          uid
          classification
          heading
          details
        }
        location {
          address
        }
        subConvenienceOptions {
          node {
            uid
            classification
            heading
            details
          }
        }
      }
      servicePlan
      servicePlanAdditionalInfo
    }
    vehicle {
      brand
      formattedLicensePlate
      licensePlate
      odometerReading {
        value
        unit
      }
      VIN
      type
      details {
        model
        modelCode
        modelYear
        engine
        engineCode
        fuelType
        transmission
        transmissionCode
        variantId
      }
    }
    dealer {
      id
    }
    events {
      eventId
      type
      state
      created
      handledBy
      handled
      origin
    }
    origin {
      source
      userName
      organization
    }
    marketAttributes {
      currencySymbol
      market
    }
    worklistId
  }
`;

export const GET_BOOKING = gql`
  query booking($bookingId: String!) {
    booking(bookingId: $bookingId) {
      ...SharedBookingFragment
      vehicleObject {
        assets {
          id
          url
        }
      }
    }
  }
  ${sharedBookingFragment}
`;

export const GET_MARKET_DATA = gql`
  query market($marketId: String!, $language: String) {
    market(marketId: $marketId) {
      currencySymbol
      servicePlans(language: $language, includeDisabled: true) {
        id
        label
      }
    }
  }
`;
